import { Component, OnInit, Input, Renderer2, ElementRef, OnChanges } from '@angular/core';
import { CarouselConfig } from 'ngx-bootstrap/carousel';
import { TCCPConstantValues } from '../../models/tccp-constants';
import { environment } from '../../../../environments/environment';
import { TCCPCommonService } from '../../services/tccp-common.service';
import { LoaderService } from '../../loader/loader.service';
import { MatDialog } from '@angular/material/dialog';
import { CarouselDialogComponent } from './carousel-dialog/carousel-dialog.component';
@Component({
  selector: 'app-image-video-carousel',
  templateUrl: './image-video-carousel.component.html',
  providers: [
    { provide: CarouselConfig, useValue: { interval: false, noPause: true, showIndicators: true } }
  ],
  styleUrls: ['./image-video-carousel.component.scss']
})
export class ImageVideoCarouselComponent implements OnInit, OnChanges {
  @Input() superSlides: Array<string> = [];
  @Input() carouselContainerWidth = 180;
  @Input() videos: Array<string> = [];
  @Input() type: string;
  @Input() startIndex = 0;
  @Input() fromFirstGuide: boolean;

  public isLoading = false;
  public windowWidth: number;
  public appBase = TCCPConstantValues[environment.applicationName];
  public imagePath: string = this.appBase.Urls.IMAGE_PATH;
  public activeSlide = 0;
  public slides: Array<string> = [];
  public appName: string = environment.applicationName;

  constructor(
    public loaderService: LoaderService,
    private renderer: Renderer2,
    private commonService: TCCPCommonService,
    public dialog: MatDialog) { }

  openDialog(currSlideIndex) {
    const curr = this.slides[currSlideIndex];
    this.dialog.open(CarouselDialogComponent,
      {
        height: '100%',
        width: '100vw',
        maxWidth: '100vw',
        panelClass: 'image-carousel-modal',
        data: { imagePath: this.imagePath, slides: this.slides, currSlide: curr + '', appName: this.appName, fromFirstGuide: this.fromFirstGuide }
      }
    );
  }

  isVideo(src) {
    return src.match(/\.(mp4|mpg|avi)$/i);
  }

  isGifFile(src) {
    const extensionArray = src.split('.');
    const extension = extensionArray[extensionArray.length - 1];
    // console.log('check Extension', src, src.split('.'), src.match(/\.(gif)$/i), extension, extension === 'gif' ? false : true);
    return extension === 'gif';
  }

  isImage(src) {
    this.loaderService.hide();
    return (/\.(gif|jpg|jpeg|tiff|png)$/i).test(src);
  }

  onImageLoad(event) {
    if (event && event.target && event.target.height > 0) {
      setTimeout(() => {
        this.isLoading = true;
        this.loaderService.hide();
      }, 500);
    }
  }

  ngOnInit() {
    this.loaderService.show();
    this.isLoading = false;
    this.windowWidth = window.innerWidth;
    // console.log('imagePath', this.imagePath, environment.applicationName);
    this.activeSlide = this.startIndex;
    this.commonService.removeZoom.subscribe(pageMode => {
      if (pageMode) {
        const el = document.querySelector('.carousel-container');
        const carouselElement = document.querySelector('.carousel-image-zoom');
        if (carouselElement) {
          document.getElementById('overlay').style.display = 'none';
          this.renderer.removeClass(el, 'carousel-image-zoom');
        }
      }
    });
  }

  switchSlide(i) {
    const el = document.querySelector('.carousel-inner');
    const carouselElement = document.querySelector('.active');
    if (carouselElement) {
      this.activeSlide = null;
      this.renderer.removeClass(el, 'active');
    }
    this.activeSlide = i;
  }

  ngOnChanges() {
    this.activeSlide = this.startIndex;
    this.slides = Object.assign([], this.superSlides);
    // console.log('image carousel ', this.slides);
  }

}
